import { get } from "lodash";
import DefinitionValue from "./definitionValue";

export default class Definition {
  id?: string;
  name: string;
  value: string;

  constructor(params?: Definition) {
    this.id = get(params, "id");
    this.name = get(params, "name", "");
    this.value = get(params, "value", "");
  }
}

export class DefinitionBatch extends Definition {
  values: string[];
  constructor(params?: DefinitionBatch) {
    super(params);
    this.values = get(params, "values", []);
  }
}

export class DefinitionList extends Definition {
  values: DefinitionValue[];

  constructor(params?: DefinitionList) {
    super(params);
    this.values = get(params, "values", []);
  }
}
